<template>
  <div>
    <have-account v-bind:haveAccountData="haveAccountData" />
    <div class="right-container">
        <div class="right-view-heading">Select account type</div>
        <div class="options-container">

          <div
            v-bind:class="{'option-box': true, 'selected-option':individualSelected}"
            v-on:click="userSelection='individual'; individualSelected=true; businessSelected=false; agencySelected=false">
            <div class="option-logo-container">
              <img src="../../assets/images/profile-logo-signup-selection.svg" alt="Individual profile" />
            </div>
            <div class="option-title">Applicant</div>
            <span class="option-subtext">Looking for a job?</span>
          </div>

          <div
            v-bind:class="{center:true, 'option-box': true, 'selected-option':businessSelected}"
            v-on:click="userSelection='business'; individualSelected=false; businessSelected=true; agencySelected=false">
            <div class="option-logo-container">
              <img src="../../assets/images/office-logo-signup-selection.svg" alt="Business profile" />
            </div>
            <div class="option-title">Business</div>
            <span class="option-subtext">Looking to hire talent?</span>
          </div>

          <div
            v-bind:class="{'option-box': true, 'selected-option':agencySelected}"
            v-on:click="userSelection='agency'; individualSelected=false; businessSelected=false; agencySelected=true">
            <div class="option-logo-container">
              <img src="../../assets/images/users-logo-signup-selection.svg" alt="Agency profile" />
            </div>
            <div class="option-title">Recruiter</div>
            <span class="option-subtext">Looking to hire talent for clients?</span>
          </div>
        </div>

        <button class="continue-button" v-on:click="handleSubmit">Continue</button>
    </div>
  </div>
</template>
<script>
import HaveAccount from '../../components/body/HaveAccount.vue';
export default {
  name: 'RightView',
  props:['coverImage'],
  components: { HaveAccount },
  data() {
    return {
      userSelection:'',
      individualSelected:false,
      agencySelected:false,
      businessSelected:false,
      selectedOption:true,
      haveAccountData: {
        haveAccountTitle: 'Already have an account?',
        haveAccountButtonText: 'Sign In',
        haveAccountLink: '/login',
      },
    };
  },
  methods:{
    handleSubmit(){
      switch(this.userSelection){
        case 'agency':
          this.$router.push(`/signup/${this.userSelection}`);
          break;
        case 'business':
          this.$router.push(`/signup/${this.userSelection}`);
          break;
        case 'individual':
          this.$router.push(`/signup/${this.userSelection}`);
          break;
      }

    }
  }
};
</script>
<style scoped>
  .right-container {
    /* border: 1px solid #E0E0E0; */
    flex-direction: column;
    align-items: center;
    display: flex;
    margin: 50vh 2.5rem;
    transform: translateY(-50%);

    /* box-shadow: 1px 1px 5px -1px rgb(23 23 23 / 36%);
    -webkit-box-shadow: 1px 1px 5px -1px rgb(23 23 23 / 36%);
    -moz-box-shadow: 1px 1px 5px -1px rgba(23,23,23,0.36); */
    max-height: 611px;
    max-width: 845px;
  }

  .right-view-heading {
    font-size: 1.875rem;
    margin: 60px 0;
    font-weight: 600;
  }

  .options-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
  }

  .option-box {
    font-size: 0.938rem;
    cursor: pointer;
    width: 241px;
    height: 220px;
    border: 1px solid #E0E0E0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 4rem;
    font-weight:600;
    border-radius: 0.625rem;
  }

  .option-box:hover {
    box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 0.55);
    -webkit-box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 1);
    -moz-box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 1);
    transition: all .3s ease-in-out;
    transform: scale(1.05);
  }

  .option-box .option-logo-container{
    margin-bottom:20px;
    width:34px;
    height:39px;
  }

  .option-logo-container img {
    width:30px;
  }

  .option-box.center {
    margin:0 1%;
  }

  .option-box .option-subtext {
    font-size: 0.65rem;
    font-weight: 400;
    color: #828282;
    margin: 0.8rem 0;
  }

  .selected-option {
    border:2px solid var(--colorPrimary);

    box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 0.55);
    -webkit-box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 1);
    -moz-box-shadow: 0px 0px 18px -2px rgba(59, 129, 179, 1);
  }

  .continue-button {
    font-size: 1.25rem;
    background: var(--colorPrimary);
    color: var(--white);
    border: none;
    outline: none;
    border-radius: 5px;
    padding: 20px 70px;
    margin: 40px 0;
  }

    @media only screen and (max-width:1270px) {

      .right-container {
        padding:15px;
      }

      .option-box {
        border: 1px solid #E0E0E0;
        padding: 8%;
        font-weight:600;
      }

      .option-box.center{
        margin:0 2%;
      }

      .continue-button {
        font-size: 1.2rem;
        border-radius: 2.5rem;
        padding: 1rem 3.9rem;
        margin: 2.5rem 0;
      }
    }

    @media only screen and (max-width:990px) {
    .right-container {
        max-height: 811px;
        max-width: 845px;
    }

    .right-view-heading {
        font-size: 1.87rem;
        margin: 30px 0;
    }

    .options-container{
      flex-direction:row;
    }

    .option-box {
        width: 200px;
        height: 200px;
        padding: 40px;
    }

    .option-box.center{
      margin:0 10px;
    }

    .continue-button {
        padding: 1rem 2rem;
    }
  }

  @media only screen and (max-width:767px) {
   .right-container {
      margin: 40px 2.5rem;
      transform: translateY(0%);
      max-height: 200vh;
      max-width: 845px;
  }

    .options-container{
      flex-direction:column;
    }

    .option-box.center{
      margin:10px 0px;
    }
  }

  @media only screen and (max-width:550px) {
    .right-container {
        max-height: 611px;
        max-width: 845px;
    }
    .right-view{
        width:100%;
    }

    .right-view-heading {
        font-size: 1.7rem;
        margin: 30px 0;
        text-align: center;
    }

    .options-container{
      flex-direction:column;
    }

    .option-box {
        width:200px;
        height: 180px;
        padding: 25px;
    }

    .option-box.center{
      margin:10px 0;
    }

    .continue-button {
        font-size: 1.1rem;
        padding: 15px 50px;
        margin: 40px 0;
    }
  }



</style>
